import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class AsyncRequestResponse extends BaseModel {
  requestData?: unknown;

  constructor(model: Partial<AsyncRequestResponse> = {}) {
    super();

    this.requestData = model.requestData;
  }
}
